import { SelectionItem } from '../../../core/component/select/select.component';

export enum MeterMediaType {
  WarmWater = 1,
  Electricity = 2,
  ColdWater = 3,
  Heating = 4,
  ChargingElectricity = 5,
}

export function getMeterNameText(mediaType: MeterMediaType): string {
  switch (mediaType) {
    case MeterMediaType.WarmWater:
      return 'CONSUMPTION.METER_NAME.HOT_WATER';
    case MeterMediaType.Electricity:
      return 'CONSUMPTION.METER_NAME.ELECTRICITY';
    case MeterMediaType.ChargingElectricity:
      return 'CONSUMPTION.METER_NAME.CHARGING_ELECTRICITY';
    case MeterMediaType.ColdWater:
      return 'CONSUMPTION.METER_NAME.COLD_WATER';
    case MeterMediaType.Heating:
      return 'CONSUMPTION.METER_NAME.HEATING';
  }
}

export function getMediaTypeUnitText(mediaType: MeterMediaType): string {
  switch (mediaType) {
    case MeterMediaType.Electricity:
    case MeterMediaType.ChargingElectricity: {
      return 'CONST.UNIT_KWH';
    }
    case MeterMediaType.ColdWater: {
      return 'CONST.UNIT_M3';
    }
    case MeterMediaType.WarmWater: {
      return 'CONST.UNIT_M3';
    }
    case MeterMediaType.Heating: {
      return 'CONST.UNIT_KWH';
    }
  }
  return undefined;
}

export const MeterMediaTypeSelection = [
  new SelectionItem('CONSUMPTION.MEDIA_TYPE.TYPES.ELECTRICITY', MeterMediaType.Electricity),
  new SelectionItem('CONSUMPTION.MEDIA_TYPE.TYPES.CHARGING_ELECTRICITY', MeterMediaType.ChargingElectricity),
  new SelectionItem('CONSUMPTION.MEDIA_TYPE.TYPES.HOT_WATER', MeterMediaType.WarmWater),
  new SelectionItem('CONSUMPTION.MEDIA_TYPE.TYPES.COLD_WATER', MeterMediaType.ColdWater),
  new SelectionItem('CONSUMPTION.MEDIA_TYPE.TYPES.HEATING', MeterMediaType.Heating),
];
